import { PaymentRound } from '../objects/PaymentRound';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class PaymentRoundEndpoint {
    /**
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this._url = url;
        this._api = api;
    }

    getUrl(paymentRound) {
        if (!(paymentRound instanceof PaymentRound)) {
            throw new TypeError('Invalid Argument');
        }
        return this._url + '/' + encodeURIComponent(paymentRound.Id);
    }

    downloadFile(paymentRound) {
        var dst = this.getUrl(paymentRound) + '/download';
        return this._api.postDownload(dst, {});
    }

    search(searchCriteria) {
        var dst = this._url + '/search';
        return this._api.postResponse(dst, searchCriteria)
            .then(x => x.parseEntity(PaymentRound));
    }
}
